// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + {"266":"82dc40ee03aa4e95","885":"7bcb7d66abd05d90"}[chunkId] + ".js";
};